var React = require('react');

function CompassSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M145 80.3A247.18 247.18 0 0 1 320 8c137 0 248 111 248 248a246.76 246.76 0 0 1-33.83 125.08l-141-109 53-116c7.61-16.65-9.54-33.8-26.19-26.2L287.46 190.4zm75 301.84c-16.65 7.61-33.81-9.55-26.2-26.2l25.7-56.24-139-107.41A247.45 247.45 0 0 0 72 256c0 137 111 248 248 248a246.64 246.64 0 0 0 122.1-32.29L286.77 351.65z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M636.64 480.55L617 505.82a16 16 0 0 1-22.46 2.81L6.18 53.9a16 16 0 0 1-2.81-22.45L23 6.18a16 16 0 0 1 22.47-2.81L633.82 458.1a16 16 0 0 1 2.82 22.45z","className":"fa-primary","key":2})]);
}

CompassSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = CompassSlash;

CompassSlash.default = CompassSlash;
